import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { uploadFile } from "../../../apis/auth";

const FileUploader = ({ title = "File", setImageUrl, previewUrl_ }) => {
  const [image, setImage] = useState(null);
  const [error, setError] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    return () => {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        setError("File size should be below 4 MB");
        setImage(null);
        setPreviewUrl("");
        return;
      }

      try {
        setError("");
        setLoading(true);
        setImage(null);
        setPreviewUrl("");
        const formData = new FormData();
        formData.append("image", file);

        const response = await uploadFile(formData);
        if (response?.data && setImageUrl) {
          const key = title.replace(/\s+/g, "").toLowerCase() + "Url";
          setImageUrl((prev) => ({
            ...prev,
            [key]: response.data.image,
          }));

          const uploadedPreviewUrl = URL.createObjectURL(file);
          setPreviewUrl(uploadedPreviewUrl);
          setImage(file);
        }
      } catch (uploadError) {
        console.error("Upload failed:", uploadError);
        setError("File upload failed. Please try again.");
      } finally {
        setLoading(false); // ✅ stop loading
      }
    }
  };

  const handleCancel = () => {
    setImage(null);
    setError("");
    setPreviewUrl("");
    setLoading(false);
  };

  const userDetails = JSON.parse(sessionStorage.getItem("info")) || {};

  return (
    <div className="profile-upload">
      <div className="mb-2">
        <h6 className="mb-1">
          Upload{" "}
          {title === "Aadharbackimageurl"
            ? "Aadhar Back Image"
            : title === "Guarantorimageurl"
              ? "Guarantor Image"
              : title === "Lockscreenimageurl"
                ? "Lock Screen Image"
                : title}
        </h6>
        <p className="fs-12">Image should be below 10 MB</p>
        {error && <p className="text-danger">{error}</p>}
      </div>
      {(!previewUrl_ ? true : userDetails.type !== "retailer") && (userDetails.type !== "customer") && (

        <div className="profile-uploader d-flex align-items-center">
          <label className="drag-upload-btn btn btn-sm btn-primary me-2">
            {image || previewUrl_ ? "Replace" : "Upload"}
            <input
              type="file"
              className="form-control image-sign"
              accept="image/*"
              onChange={handleFileChange}
              hidden
            />
          </label>
          <button
            type="button"
            className="btn btn-light btn-sm"
            onClick={handleCancel}
          >
            Cancel
          </button>
        </div>
      )}

      {loading && (
        <div className="mt-2">
          <span
            className="spinner-border spinner-border-sm text-primary"
            role="status"
            aria-hidden="true"
          ></span>{" "}
          Uploading...
        </div>
      )}

      {!loading && (previewUrl_ || (image && previewUrl)) && (
        <div className="mt-3">
          <p>Preview: </p>
          <img
            src={previewUrl || previewUrl_}
            alt="Preview"
            className="img-thumbnail"
            style={{
              maxWidth: "150px",
              maxHeight: "150px",
            }}
          />
        </div>
      )}
    </div>
  );
};

FileUploader.propTypes = {
  title: PropTypes.string,
  setImageUrl: PropTypes.func.isRequired,
};

export default FileUploader;
